<template>
  <v-container>
    <v-row>
      <v-col v-for="(item, i) in userStudyLists" :key="i" cols="12" sm="6">
        <v-card
          flat
          :to="{ name: 'StudyListDetail', params: { id: item.id.toString() } }"
        >
          <v-card-title v-text="item.name"></v-card-title>

          <v-card-subtitle
            v-text="
              `${item.item_count} ${pluralize(
                item.item_count,
                'term',
                'terms'
              )} • ${item.reviewed_today_count} reviewed today`
            "
          ></v-card-subtitle>

          <v-card-actions>
            <v-btn
              text
              color="accent-4"
              :to="{ name: 'AudioStudy', params: { id: item.id.toString() } }"
            >
              Study
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col :key="'__newlist__'" cols="12">
        <v-btn
          min-height="5rem"
          height="100%"
          depressed
          block
          large
          @click="displayAddStudyListDialog"
          color="primary"
          outlined
        >
          <v-icon>mdi-plus</v-icon> Create new list
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="showAddStudyListDialog" max-width="800px">
      <AddStudyList v-bind:onFinish="closeAddStudyListDialog" />
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AddStudyList from "@/components/AddStudyList.vue";

import PlayerService from "@/common/player.service";

export default {
  name: "RecentLists",

  methods: {
    ...mapActions(["fetchUserStudyLists", "play", "updatePlayingInfo"]),
    onStudyClick(item) {
      PlayerService.setCurrentStudyList(item.id);
      this.updatePlayingInfo({ subtitle: item.name });
      this.play();
    },
    pluralize(n, singular, plural) {
      return n !== 1 ? plural : singular;
    },
    displayAddStudyListDialog() {
      this.showAddStudyListDialog = true;
    },
    closeAddStudyListDialog() {
      this.showAddStudyListDialog = false;
    },
  },

  data: () => ({
    showAddStudyListDialog: false,
  }),

  computed: mapGetters(["userStudyLists"]),

  created() {
    this.fetchUserStudyLists();
  },

  components: {
    AddStudyList,
  },
};
</script>
